import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { RossModule } from "src/@ross/ross.module";
import { RossSharedModule } from "src/@ross/shared.module";
import { rossConfig } from "./ross-config";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { PagesModule } from "./pages/pages.module";

import { LoginExternalComponent } from "./pages/login-external/login-externalcomponent";
import { LoadingComponent } from "./pages/loading/loading.component";

import { registerLocaleData } from "@angular/common";
import localeAr from "@angular/common/locales/es-AR";
import { NgChartsModule } from "ng2-charts";
import { NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QuillModule } from 'ngx-quill';
import { IMaskModule } from "angular-imask";
import { DirectivesModule } from './shared/directives/directives.module';
registerLocaleData(localeAr, "es-AR");

@NgModule({
  declarations: [AppComponent, LoginExternalComponent, LoadingComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    RossModule.forRoot(rossConfig),
    RossSharedModule,

    AppRoutingModule,
    PagesModule,
    CoreModule,
    MatNativeDateModule,
    MatIconModule,
    NgChartsModule,

    IMaskModule,
    NgxMaskModule.forRoot(),
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    DirectivesModule
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: "es-AR" }],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconRegistry.addSvgIconSet(
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/mdi.svg")
    );
  }
}
